import { createTheme } from "@mui/material/styles";

export const createAppTheme = (mode) =>
  createTheme({
    palette: {
      mode,
      primary: {
        main: mode === "dark" ? "#0b7465" : "#96b795",
      },
      secondary: {
        main: mode === "dark" ? "#96b795" : "#0b7465",
      },
      success: {
        main: "#96b795",
      },
      warning: {
        main: "#b2e5e2",
      },
      info: {
        main: "#0b7465",
      },
      error: {
        main: "#E38540",
      },
      background: {
        default: mode === "dark" ? "#062329" : "#ffffff",
        paper: mode === "dark" ? "#062329" : "#ffffff",
      },
      text: {
        primary: mode === "dark" ? "#ffffff" : "#0C1A1A",
        secondary: mode === "dark" ? "#96b795" : "#4a8379",
      },
    },
    typography: {
      fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
    },
    spacing: [0, 4, 8, 16, 32, 64],
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
  });
//"#4a8379" secondary
